import { c as _c } from "react/compiler-runtime";
import { CustomLink } from '@/app/_components/CustomLink';
import type { MedianIncomeYear, MedianIncomeYearBundle } from '../constants';
import { MEDIAN_INCOME_BY_YEAR } from '../constants';
interface PolicyCardsProps {
  year: MedianIncomeYear;
  /** 사용자 비율에서 매핑된 가장 가까운 구간(%). null 이면 empty state. */
  activeTier: number | null;
}
const CARD_CLASS = 'flex items-start gap-12 rounded-small border-1 border-Gray-100 bg-Gray-25 p-16';
const CARD_HOVER_CLASS = 'transition-colors hover:border-B-300 hover:bg-B-25';

/**
 * ⑤ 정책 카드 — `activeTier` 에 해당하는 정책 목록을 카드 한 줄에 하나씩 노출.
 * - `url` 이 있으면 카드 전체가 CustomLink — 클릭 시 정책 상세로 이동.
 * - `url` 이 없으면 일반 article(클릭 비활성).
 */
export const PolicyCards = t0 => {
  const $ = _c(7);
  const {
    year,
    activeTier
  } = t0;
  const {
    policiesByTier
  } = MEDIAN_INCOME_BY_YEAR[year];
  let t1;
  if ($[0] !== activeTier || $[1] !== policiesByTier) {
    const policies = activeTier === null ? [] : policiesByTier[String(activeTier)] ?? [];
    let t2;
    if ($[3] !== activeTier) {
      t2 = activeTier === null ? "\uC911\uC704\uC18C\uB4DD \uAD6C\uAC04 \uC815\uCC45" : <>중위소득 <span className="text-B-600">{activeTier}%</span> 구간 주요 정책</>;
      $[3] = activeTier;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] !== t2) {
      t3 = <h2 className="font-700 text-Gray-900 typo-h5 mobile-tablet:px-16 mobile-tablet:typo-h6">{t2}</h2>;
      $[5] = t2;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t1 = <section className="flex flex-col gap-12">{t3}{activeTier === null ? <p className="rounded-small bg-Gray-50 px-16 py-24 text-center text-Gray-600 typo-body4 mobile-tablet:mx-16">위 표에서 구간을 선택하거나 계산기를 사용해 보세요.</p> : policies.length === 0 ? <p className="rounded-small bg-Gray-50 px-16 py-24 text-center text-Gray-600 typo-body4 mobile-tablet:mx-16">해당 구간의 정책이 없습니다.</p> : <div className="flex flex-col gap-12 mobile-tablet:px-16">{policies.map(_temp)}</div>}</section>;
    $[0] = activeTier;
    $[1] = policiesByTier;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
function _temp(policy) {
  const body = <div className="flex min-w-0 flex-1 flex-col gap-8"><div className="font-700 text-Gray-900 typo-body3">{policy.name}</div><p className="text-Gray-700 typo-body4">{policy.summary}</p><dl className="flex flex-col gap-4 text-Gray-600 typo-caption1"><div className="flex gap-8"><dt className="shrink-0 font-600">대상</dt><dd>{policy.target}</dd></div><div className="flex gap-8"><dt className="shrink-0 font-600">금액</dt><dd>{policy.amount}</dd></div></dl></div>;
  return policy.url ? <CustomLink key={policy.slug} href={policy.url} className={`${CARD_CLASS} ${CARD_HOVER_CLASS}`}>{body}<span aria-hidden="true" className="shrink-0 self-center text-Gray-400 typo-body3">→</span></CustomLink> : <article key={policy.slug} className={CARD_CLASS}>{body}</article>;
}